import { render, staticRenderFns } from "./ExcelUpload.vue?vue&type=template&id=bdaca20a&scoped=true"
import script from "./ExcelUpload.vue?vue&type=script&lang=js"
export * from "./ExcelUpload.vue?vue&type=script&lang=js"
import style0 from "./ExcelUpload.vue?vue&type=style&index=0&id=bdaca20a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaca20a",
  null
  
)

export default component.exports